<div style="margin: 11px" id="strength" #strength>
  <small [class.text-red-500]="score < 71 && score > 0">{{ barLabel }} </small>
  <ul id="strengthBar" class="ms-4">
    <li class="point" [style.background-color]="bar0"></li>
    <li class="point" [style.background-color]="bar1"></li>
    <li class="point" [style.background-color]="bar2"></li>
    <li class="point" [style.background-color]="bar3"></li>
    <li class="point" [style.background-color]="bar4"></li>
  </ul>
</div>
